/* Product-level comparison. Public facts and variant money come from Shopify Liquid. */
(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (host && host.document) api.boot(host);
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var KEY = 'pg:compare';
  var MAX = 3;

  function validHandle(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 255 &&
      /^[\p{L}\p{M}\p{N}_™®-]+$/u.test(value) && encodeURIComponent(value).length <= 2048;
  }
  function normalize(value) {
    if (!Array.isArray(value)) return [];
    return value.filter(function (handle, index) { return validHandle(handle) && value.indexOf(handle) === index; }).slice(0, MAX);
  }
  function createStore(storage, changed) {
    var memory = null;
    function read() {
      if (memory) return memory.slice();
      try { return normalize(JSON.parse(storage.getItem(KEY) || '[]')); } catch (_) { return []; }
    }
    function write(list) {
      list = normalize(list);
      var persisted = true;
      try { storage.setItem(KEY, JSON.stringify(list)); memory = null; }
      catch (_) { memory = list; persisted = false; }
      if (changed) changed({ count: list.length, list: list, persisted: persisted });
      return { ok: true, persisted: persisted };
    }
    function toggle(handle) {
      if (!validHandle(handle)) return { ok: false, error: 'invalid' };
      var list = read(); var index = list.indexOf(handle);
      if (index >= 0) list.splice(index, 1);
      else if (list.length >= MAX) return { ok: false, error: 'limit' };
      else list.push(handle);
      return write(list);
    }
    return { read: read, write: write, toggle: toggle, remove: function (handle) { return write(read().filter(function (item) { return item !== handle; })); } };
  }
  function productPath(root, handle) {
    var prefix = typeof root === 'string' && /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/?)?$/i.test(root) ? root : '/';
    return prefix.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle);
  }
  function previewId(search) {
    var id = new URLSearchParams(search || '').get('preview_theme_id');
    return id && /^[0-9]{1,20}$/.test(id) ? id : '';
  }
  function sectionPath(root, handle, search) {
    var params = new URLSearchParams({ section_id: 'pg-product-compare-data' });
    var preview = previewId(search);
    if (preview) params.set('preview_theme_id', preview);
    return productPath(root, handle) + '?' + params.toString();
  }
  function productUrl(value, root, handle, variant, origin, search) {
    try {
      var url = new URL(value, origin);
      if (url.origin !== origin || url.username || url.password) return null;
      var localPath = productPath(root, handle);
      if (url.pathname !== localPath && url.pathname !== productPath('/', handle)) return null;
      if (url.searchParams.get('variant') !== variant) return null;
      url.pathname = localPath;
      url.hash = '';
      var preview = previewId(search);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.pathname + url.search;
    } catch (_) { return null; }
  }
  function imageUrl(value, origin) {
    if (typeof value !== 'string' || !value || value.length > 2048) return null;
    try {
      var url = new URL(value, origin);
      return url.protocol === 'https:' && !url.username && !url.password &&
        (url.origin === origin || url.hostname === 'cdn.shopify.com') ? url.href : null;
    } catch (_) { return null; }
  }
  function facts(value) {
    if (!Array.isArray(value)) return [];
    var seen = new Set();
    return value.slice(0, 30).filter(function (fact) {
      if (!fact || typeof fact.key !== 'string' || !/^[a-z][a-z0-9_]{0,63}$/.test(fact.key) ||
          typeof fact.label !== 'string' || !fact.label.trim() || fact.label.length > 120 ||
          typeof fact.value !== 'string' || !fact.value.trim() || fact.value.length > 1000 || seen.has(fact.key)) return false;
      seen.add(fact.key); return true;
    }).map(function (fact) { return { key: fact.key, label: fact.label.trim(), value: fact.value.trim() }; });
  }
  function resolveProduct(data, handle, root, origin, search) {
    if (!data || data.handle !== handle || typeof data.title !== 'string' || !data.title.trim() ||
        typeof data.price !== 'string' || !data.price.trim() || typeof data.available !== 'boolean' ||
        typeof data.variant_id !== 'string' || !/^[1-9]\d{0,19}$/.test(data.variant_id)) throw new Error('Invalid product data');
    var url = productUrl(data.url, root, handle, data.variant_id, origin, search);
    if (!url) throw new Error('Invalid product URL');
    return Object.assign({}, data, { url: url, image: imageUrl(data.image, origin), facts: facts(data.facts) });
  }
  function comparisonRows(products, copy) {
    var fields = new Map();
    products.forEach(function (product) {
      if (product) product.facts.forEach(function (fact) { if (!fields.has(fact.key)) fields.set(fact.key, fact.label); });
    });
    var rows = [];
    fields.forEach(function (label, key) {
      rows.push({ key: key, label: label, values: products.map(function (product) {
        var fact = product && product.facts.find(function (item) { return item.key === key; });
        return fact ? fact.value : null;
      }) });
    });
    ['vendor', 'type', 'sku', 'available'].forEach(function (key, index) {
      rows.push({ key: key, label: copy[['brand', 'type', 'sku', 'availability'][index]], values: products.map(function (product) {
        if (!product) return null;
        if (key === 'available') return product.available ? copy.inStock : copy.outOfStock;
        return typeof product[key] === 'string' && product[key].trim() ? product[key] : null;
      }) });
    });
    return rows;
  }

  function mountPage(root, win, store) {
    if (!root || root.dataset.pgComparePageWired === '1') return;
    root.dataset.pgComparePageWired = '1';
    var doc = root.ownerDocument || win.document;
    var nodes = {};
    ['i18n', 'empty', 'content', 'grid', 'clear', 'heading', 'status', 'fallback', 'scroll-hint'].forEach(function (name) {
      nodes[name] = root.querySelector('[data-pg-compare-' + name + ']');
    });
    var copy = {};
    try { copy = JSON.parse(nodes.i18n.textContent); } catch (_) {}
    var prefix = root.getAttribute('data-product-root');
    var cache = new Map(); var controllers = new Set(); var generation = 0; var disposed = false; var storageFailed = false;
    function text(key) { return copy[key] || ''; }
    function element(tag, className, value) {
      var node = doc.createElement(tag);
      if (className) node.className = className;
      if (value !== undefined) node.textContent = value;
      return node;
    }
    function link(url, label, className) {
      var node = element('a', className, label); node.setAttribute('href', url); return node;
    }
    function fallback(photo) {
      photo.replaceChildren();
      if (nodes.fallback && nodes.fallback.content) photo.appendChild(nodes.fallback.content.cloneNode(true));
      else photo.textContent = text('image');
    }
    function fetchProduct(handle) {
      if (cache.has(handle)) return cache.get(handle);
      var controller = new win.AbortController(); controllers.add(controller);
      var timeout = win.setTimeout(function () { controller.abort(); }, 10000);
      var promise = win.fetch(sectionPath(prefix, handle, win.location.search), {
        credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' }
      }).then(async function (response) {
        if (response.status === 404) return { kind: 'missing' };
        if (!response.ok) throw new Error('Product response');
        var html = await response.text();
        if (html.length > 100000) throw new Error('Unexpected product payload');
        var parsed = new win.DOMParser().parseFromString(html, 'text/html');
        var payload = parsed.querySelector('script[data-pg-product-compare-data]');
        if (!payload) throw new Error('Product data section missing');
        return { kind: 'product', product: resolveProduct(JSON.parse(payload.textContent), handle, prefix, win.location.origin, win.location.search) };
      }).catch(function () { return { kind: 'error' }; }).finally(function () {
        win.clearTimeout(timeout); controllers.delete(controller);
      });
      cache.set(handle, promise); return promise;
    }
    function card(handle, result) {
      var product = result.product;
      var title = product ? product.title : handle.replace(/-/g, ' ');
      var url = product ? product.url : productPath(prefix, handle);
      var article = element('div', 'pg-cmp__card');
      var remove = element('button', 'pg-cmp__card-remove', '×'); remove.type = 'button';
      remove.setAttribute('data-pg-compare-remove', handle);
      remove.setAttribute('aria-label', text('remove') + ': ' + title);
      remove.addEventListener('click', function () { store.remove(handle); nodes.heading.focus(); });
      article.appendChild(remove);
      var photo = link(url, '', 'pg-cmp__photo'); photo.setAttribute('aria-label', title);
      if (product && product.image) {
        var img = element('img'); img.src = product.image; img.alt = ''; img.width = 480; img.height = 360; img.loading = 'lazy';
        img.addEventListener('error', function () { fallback(photo); }, { once: true }); photo.appendChild(img);
      } else fallback(photo);
      article.appendChild(photo);
      var heading = element('h2', 'pg-cmp__name'); heading.appendChild(link(url, title)); article.appendChild(heading);
      if (product) {
        if (product.variant_title) article.appendChild(element('p', 'pg-cmp__variant', product.variant_title));
        var price = element('p', 'pg-cmp__price');
        if (product.compare_price) price.appendChild(element('s', '', product.compare_price));
        price.appendChild(element('span', '', product.price)); article.appendChild(price);
        if (!product.facts.length) article.appendChild(element('p', 'pg-cmp__card-note', text('no_facts')));
      } else {
        article.appendChild(element('p', 'pg-cmp__card-note', text(result.kind === 'missing' ? 'unavailable' : 'load_error')));
        if (result.kind === 'error') {
          var retry = element('button', 'pg-cmp__retry', text('retry')); retry.type = 'button';
          retry.addEventListener('click', function () { cache.delete(handle); render(); nodes.heading.focus(); }); article.appendChild(retry);
        }
      }
      article.appendChild(link(url, text('view'), 'pg-cmp__view')); return article;
    }
    function table(handles, results) {
      var products = results.map(function (result) { return result.product || null; });
      var tableNode = element('table', 'pg-cmp__table');
      tableNode.style.minWidth = handles.length === 1 ? '100%' : String(160 + handles.length * 235) + 'px';
      tableNode.appendChild(element('caption', '', text('table_label')));
      var head = element('thead'); var headerRow = element('tr');
      var corner = element('th', '', text('product')); corner.setAttribute('scope', 'col'); headerRow.appendChild(corner);
      handles.forEach(function (handle, index) {
        var th = element('th'); th.setAttribute('scope', 'col'); th.appendChild(card(handle, results[index])); headerRow.appendChild(th);
      });
      head.appendChild(headerRow); tableNode.appendChild(head);
      var body = element('tbody');
      comparisonRows(products, copy).forEach(function (row) {
        var tr = element('tr'); tr.setAttribute('data-pg-compare-row', row.key);
        var heading = element('th', '', row.label); heading.setAttribute('scope', 'row'); tr.appendChild(heading);
        row.values.forEach(function (value) {
          var cell = element('td');
          if (value === null) {
            var mark = element('span', 'pg-cmp__missing', '–'); mark.setAttribute('aria-hidden', 'true'); cell.appendChild(mark);
            cell.appendChild(element('span', 'visually-hidden', text('missing_value')));
          } else cell.textContent = value;
          tr.appendChild(cell);
        });
        body.appendChild(tr);
      });
      tableNode.appendChild(body); return tableNode;
    }
    async function render() {
      var version = ++generation; var handles = store.read();
      nodes.empty.hidden = handles.length > 0; nodes.content.hidden = handles.length === 0;
      nodes.grid.replaceChildren(); nodes.grid.setAttribute('aria-busy', handles.length ? 'true' : 'false');
      nodes.status.textContent = storageFailed ? text('storage_error') : (handles.length ? text('loading') : '');
      nodes['scroll-hint'].hidden = handles.length < 2;
      if (!handles.length) return;
      var results = await Promise.all(handles.map(fetchProduct));
      if (disposed || version !== generation) return;
      nodes.grid.replaceChildren(table(handles, results)); nodes.grid.setAttribute('aria-busy', 'false');
      nodes.status.textContent = storageFailed ? text('storage_error') : (results.some(function (result) { return result.kind === 'error'; }) ? text('load_error') : '');
    }
    function changed(event) {
      if (event.detail && typeof event.detail.persisted === 'boolean') storageFailed = !event.detail.persisted;
      render();
    }
    function clear() { store.write([]); nodes.heading.focus(); }
    nodes.clear.addEventListener('click', clear);
    doc.addEventListener('pg:compare-updated', changed);
    render();
    return { render: render, dispose: function () {
      disposed = true; generation += 1; controllers.forEach(function (controller) { controller.abort(); });
      doc.removeEventListener('pg:compare-updated', changed); nodes.clear.removeEventListener('click', clear);
    } };
  }

  function boot(win) {
    if (win.PGCompare) return;
    var doc = win.document; var storage;
    try { storage = win.localStorage; } catch (_) { storage = { getItem: function () { return null; }, setItem: function () { throw new Error('Storage unavailable'); } }; }
    var store = createStore(storage, function (detail) { doc.dispatchEvent(new win.CustomEvent('pg:compare-updated', { detail: detail })); });
    win.PGCompare = store;
    function toast(message) {
      var node = doc.createElement('div'); node.textContent = message; node.setAttribute('role', 'status');
      node.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:var(--pg-ink);color:var(--pg-bg);padding:10px 18px;border-radius:999px;font-size:13px;font-weight:600;z-index:9999;';
      doc.body.appendChild(node); win.setTimeout(function () { node.remove(); }, 2700);
    }
    function sync() {
      var list = store.read();
      doc.querySelectorAll('[data-pg-compare-toggle]').forEach(function (button) {
        var on = list.indexOf(button.getAttribute('data-product-handle')) >= 0;
        button.setAttribute('data-pg-in-compare', on ? 'true' : 'false'); button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      doc.querySelectorAll('[data-pg-compare-count]').forEach(function (node) {
        node.textContent = String(list.length); node.setAttribute('data-empty', list.length === 0 ? 'true' : 'false');
        var chip = node.closest('.pg-mini-chip--cmp'); if (chip) chip.setAttribute('data-empty', list.length === 0 ? 'true' : 'false');
      });
    }
    var pages = new Map();
    function start() {
      doc.querySelectorAll('[data-pg-compare-toggle]').forEach(function (button) {
        if (button.dataset.pgCompareWired === '1') return; button.dataset.pgCompareWired = '1';
        button.addEventListener('click', function (event) {
          event.preventDefault(); event.stopPropagation();
          var result = store.toggle(button.getAttribute('data-product-handle'));
          if (result.error === 'limit') toast(win.pgCompareMaxMsg || 'Maximal 3 Produkte vergleichen.');
        });
      });
      doc.querySelectorAll('[data-pg-compare]').forEach(function (root) { if (!pages.has(root)) pages.set(root, mountPage(root, win, store)); });
      sync();
    }
    doc.addEventListener('pg:compare-updated', sync);
    doc.addEventListener('pg:cards-updated', start); doc.addEventListener('shopify:section:load', start);
    doc.addEventListener('shopify:section:unload', function (event) {
      pages.forEach(function (page, root) { if (event.target.contains(root)) { if (page) page.dispose(); pages.delete(root); } });
    });
    win.addEventListener('storage', function (event) { if (event.key === KEY || event.key === null) doc.dispatchEvent(new win.CustomEvent('pg:compare-updated', { detail: {} })); });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  }
  return { KEY: KEY, MAX: MAX, validHandle: validHandle, createStore: createStore, sectionPath: sectionPath, resolveProduct: resolveProduct, comparisonRows: comparisonRows, mountPage: mountPage, boot: boot };
});
